export default __webpack_public_path__ + "static/media/group-hra-ver-2-mobile.84f52576.svg";